<template>
  <v-dialog v-model="open" persistent max-width="800px">
    <material-card color="primary" :title="title" :text="!isNew ? item.name : ''">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm12 md12>
               <v-autocomplete
                  style="padding-top:2px"
                  clearable
                  md4
                  chips
                  multiple
                  v-model="item.protocols"
                  :items="protocols"
                  label="Protocols"
                  item-value="id"
                  item-text="name"
                  :rules="validators.external_user.protocol"
                ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-select
                clearable
                md4
                v-model="item.type"
                :items="types"
                label="Type"
                :rules="validators.external_user.type"
                :disabled="!isNew"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-text-field
                label="Name"
                :disabled="!isNew"
                v-model="item.name"
                :rules="validators.external_user.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <!-- aggiunto v-if="item.email !== undefined", si spaccava  -->
              <v-text-field
                label="Email"
                v-model="item.email"
                :rules="validators.external_user.email"
              ></v-text-field>
              <!-- aggiunto v-if="item.email !== undefined", si spaccava  -->
            </v-flex>
            
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          v-if="$can('upsert', 'external_user')"
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave() && !validForm"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/external_user";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: true,
      validators,
      types: ['Medical monitor', 'Personnel']
    };
  },
  mounted() {
  },
  watch: {
    open() {
      if (this.isNew) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    open() {
      return this.$store.getters.externalUserDialog;
    },
    item: {
      get() {
        return this.$store.getters.externalUserItem;
      },
      set() {}
    },
    external_users() {
      return this.$store.getters.external_users;
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New External User" : "Edit External User";
    }
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
        this.$store.commit("app/externalUserItem", newItem);
      });
    },
    close() {
      this.$store.dispatch("app/closeExternalUserDialog");
    },
    checkSave() {
      return !this.isNew
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "External User updated correctly",
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$store.commit("app/externalUserItem", newItem);
          this.$root.$emit('updateExternalUsers', newItem);
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the External User update. " +
              e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
